import styled from 'styled-components';
import { Button, TextField } from '@web-chat-core/ui-kit';

export const ShareButton = styled(Button)`
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0;
    white-space: nowrap;

    &:hover {
        background: none;

        &:after {
            left: auto;
            right: 0;
            transform: translateY(-100%);

            color: ${(props) => props.theme.root.colors.basicColors.inverted['100%']};
        }

        svg path {
            fill: ${(props) => props.theme.root.colors.basicColors['90%']};
        }
    }

    svg path {
        fill: ${(props) => props.theme.root.colors.basicColors['55%']};
    }
`;

export const ShareTextField = styled(TextField)`
    flex-grow: 1;
    min-width: 0;

    span {
        margin-bottom: 0;
    }

    div {
        background: none;
        margin-bottom: 0;
    }

    input {
        text-overflow: ellipsis;
    }
`;

export const ShareLinkLayout = styled.div`
    background: ${(props) => props.theme.root.colors.basicColors['6%']};
    border-radius: 12px;
    padding: 0 12px 0 0;
    width: 100%;
    min-width: 0;

    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    flex-grow: 1;
`;
